// extracted by mini-css-extract-plugin
module.exports = {"container":"NewsPage_container__zzNrh","lotTitle":"NewsPage_lotTitle__3IGOJ"};